import PropTypes from 'prop-types'
import React from 'react'
import get from 'lodash-es/get'
import intersection from 'lodash-es/intersection'

import FilterItem from './filterItem'
import FilterList from '../../../../shared/components/filterList'
import SearchLink from '../../../../shared/containers/searchLinkContainer'
import filterParamsConfig from '../../../../../common/constants/filterParamsConfig'
import { getConfigBySite } from '../../../../../config/sites'

const excludeFrom = (filters, key) => {
  return filters.filter(filter => filter !== key)
}

const activeFilters = (parsedLocation, currentSite) => {
  let filters = intersection(
    Object.keys(parsedLocation),
    Object.keys(filterParamsConfig)
  )

  // all sites except themeforest hide the current category selection
  if (!getConfigBySite(currentSite, 'show_category_in_selected_filters')) {
    filters = excludeFrom(filters, 'category')
  }

  // if price_min and price_max are selected at the same time, only show one of them.
  if (parsedLocation.price_min && parsedLocation.price_max) {
    filters = excludeFrom(filters, 'price_min')
  }

  // if length_min and length_max are selected at the same time, only show one of them.
  if (parsedLocation.length_min && parsedLocation.length_max) {
    filters = excludeFrom(filters, 'length_min')
  }

  return sortByConfiguredOrder(filters)
}

const sortByConfiguredOrder = filters => {
  return filters.sort(
    (filter1, filter2) =>
      get(filterParamsConfig, `${filter1}.order`) >
      get(filterParamsConfig, `${filter2}.order`)
  )
}

const clearAllLinkParams = locationParams => {
  return locationParams.term
    ? { category: 'all', term: locationParams.term }
    : { category: 'all' }
}

const SelectedFilters = props => {
  const { locationParams, currentSite } = props
  const filters = activeFilters(locationParams, currentSite)
  const hasSelectedFilter = filters.length > 0

  return (
    <div id="selected-filters">
      {!hasSelectedFilter && (
        <div className="search-facet-refine">Refine your results:</div>
      )}

      {hasSelectedFilter && (
        <div className="search-facet">
          <div className="search-facet-actives__remove-all">
            Your filters:
            <SearchLink locationParams={clearAllLinkParams(locationParams)}>
              Clear all
            </SearchLink>
          </div>
          <div className="search-facet-actives__facet-wrapper">
            {filters.map((param, key) => {
              return (
                <FilterList
                  FilterItem={FilterItem}
                  parsedLocation={locationParams}
                  param={param}
                  key={key}
                />
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

SelectedFilters.propTypes = {
  locationParams: PropTypes.object.isRequired
}

export default SelectedFilters
